<div class="actions-left">
  <rt-group variant="horizontal">
    @if (canManage) {
      <rt-group
        [class.keep-radius]="selectedCount === 0"
        variant="horizontal stacked"
        layout-align-items-center
        margin-right-small
        class="toolbar-group"
      >
        <rt-bulk-select
          variant="outline"
          [allSelected]="allSelected"
          [selectedCount]="selectedCount"
          [disabled]="viewSelectedCount === 0 && selectedCount === 0 && viewCount === 0"
          (select)="toggleSelectAllOnPage.emit($event)"
        >
        </rt-bulk-select>

        @if (selectedCount > 0) {
          <rt-button
            [disabled]="bulkActionPending"
            (click)="bulkMerge.emit()"
            class="merge-button"
            variant="outline"
          >
            <rt-icon name="merge-type"></rt-icon>
            <span>{{ 'app.tags_manager.merge' | translate }}</span>
          </rt-button>
        }

        @if (selectedCount > 0) {
          <rt-button
            [disabled]="bulkActionPending"
            (click)="bulkDelete.emit()"
            class="last-of-type"
            variant="outline"
          >
            <rt-icon name="delete"></rt-icon>
            <span>{{ 'app.common.delete' | translate }}</span>
          </rt-button>
        }

        @if (selectedCount > 0) {
          <rt-icon-button
            (click)="clearSelection.emit()"
            variant="plain"
            iconName="close"
            shape="square"
          >
          </rt-icon-button>
        }
      </rt-group>
    }

    <rt-form-field [class.u-media-min-lg]="selectedCount > 0">
      <rt-input
        [formControl]="queryControl"
        [hasClearButton]="true"
        (reset)="queryControl.reset('')"
        variant="rounded"
        placeholder="{{ 'app.tags_manager.search_placeholder.departments' | translate }}"
      >
        <rt-icon prefix name="search"></rt-icon>
      </rt-input>
    </rt-form-field>
  </rt-group>
</div>
<div class="actions-right">
  <rt-group variant="horizontal">
    <rt-pagination-counter
      [total]="totalCount"
      [start]="pageItemsStart"
      [end]="pageItemsEnd"
      [label]="'app.plurals.department' | translate: { count: totalCount }"
      margin-right-small
    >
    </rt-pagination-counter>

    @if (pagination.pagesCount > 1) {
      <rt-pagination
        [page]="pagination.page"
        [pagesCount]="pagination.pagesCount"
        (pageChange)="pageChange.emit($event)"
        margin-right-small
      >
      </rt-pagination>
    }

    @if (canManage) {
      <rt-button variant="primary" (click)="createNew.emit()">
        <rt-icon name="add"></rt-icon>
        <span>{{ 'app.common.new' | translate }}</span>
      </rt-button>
    }
  </rt-group>
</div>
